export default __webpack_public_path__ + "static/media/jay.1974e760.jpg";